import { z } from 'zod'

export default z.object({
  __typename: z.literal('CallReportAttachment').default('CallReportAttachment'),
  id: z.string(),
})
